import React                from "react";
import PropTypes            from "prop-types";
import { connect }          from "react-redux";
import MediaType            from "dashboard/dist/Core/MediaType";
import Status               from "dashboard/dist/Core/Status";
import Utils                from "dashboard/dist/Utils/Utils";

// Components
import MediaField           from "Components/Utils/Media/MediaField";
import EditDialog           from "dashboard/dist/Components/EditDialog";
import InputField           from "dashboard/dist/Components/InputField";

// Actions
import {
    fetchAdvice, editAdvice,
} from "Actions/Admin/Setup/AdviceActions";



/**
 * The Advice Edit Dialog
 */
class AdviceEdit extends React.Component {
    // The Initial Data
    initialData = {
        adviceID : 0,
        name     : "",
        message  : "",
        image    : "",
        status   : Status.getID("ACTIVE"),
    }

    // The Current State
    state = {
        loading : false,
        data    : { ...this.initialData },
        errors  : {},
    }



    /**
     * Get the Data when the Element ID changes
     * @param {Object} prevProps
     * @returns {Void}
     */
    componentDidUpdate(prevProps) {
        const { open, edition, elemID, elem, fetchAdvice } = this.props;
        let loading = false;
        let data    = null;

        // Dialog Opens
        if (open && !prevProps.open) {
            data = { ...this.initialData };
            // Load new data
            if (elemID) {
                fetchAdvice(elemID);
                loading = true;
            }

        // Data Updated
        } else if (prevProps.edition !== edition && elemID) {
            data = Utils.extend(this.initialData, elem);
        }

        // Set the State
        if (data) {
            this.setState({ data, loading, errors : {} });
        }
    }

    /**
     * Handles the Input Change
     * @param {String} name
     * @param {*}      value
     * @returns {Void}
     */
    handleChange = (name, value) => {
        this.setState({
            data   : { ...this.state.data,   [name] : value },
            errors : { ...this.state.errors, [name] : ""    },
        });
    }

    /**
     * Handles the Submit
     * @returns {Promise}
     */
    handleSubmit = async () => {
        const { data, loading } = this.state;
        if (!loading) {
            this.setState({ loading : true, errors : {} });
            try {
                await this.props.editAdvice(data);
                this.setState({ loading : false });
                this.props.onSubmit();
            } catch (errors) {
                this.setState({ loading : false, errors });
            }
        }
    }



    /**
     * Does the Render
     * @returns {Object}
     */
    render() {
        const { elemID, open, onClose } = this.props;
        const { data, loading, errors } = this.state;

        return <EditDialog
            open={open}
            icon="advice"
            title={!!elemID ? "ADVICES_EDIT_TITLE" : "ADVICES_CREATE_TITLE"}
            error={errors.form}
            onSubmit={this.handleSubmit}
            onClose={onClose}
            isLoading={loading}
        >
            <InputField
                name="name"
                label="ADVICES_ITS_NAME"
                value={data.name}
                error={errors.name}
                onChange={this.handleChange}
                isRequired
            />
            <InputField
                type="textarea"
                name="message"
                label="ADVICES_MESSAGE"
                value={data.message}
                onChange={this.handleChange}
            />
            <MediaField
                name="image"
                label="ADVICES_IMAGE"
                mesdiaType={MediaType.IMAGE}
                mediaPath="consejos"
                value={data.image}
                error={errors.image}
                onChange={this.handleChange}
                isRequired
            />
            <InputField
                type="select"
                name="status"
                label="GENERAL_STATUS"
                value={data.status}
                error={errors.status}
                onChange={this.handleChange}
                options={Status.getSelect()}
                withNone
                isRequired
                shrinkLabel
            />
        </EditDialog>;
    }



    /**
     * The Property Types
     * @typedef {Object} propTypes
     */
    static propTypes = {
        fetchAdvice : PropTypes.func.isRequired,
        editAdvice  : PropTypes.func.isRequired,
        open        : PropTypes.bool.isRequired,
        onClose     : PropTypes.func.isRequired,
        onSubmit    : PropTypes.func.isRequired,
        edition     : PropTypes.number.isRequired,
        elem        : PropTypes.object.isRequired,
        elemID      : PropTypes.number,
    }

    /**
     * Maps the State to the Props
     * @param {Object} state
     * @returns {Object}
     */
    static mapStateToProps(state) {
        return {
            edition : state.advice.edition,
            elem    : state.advice.elem,
        };
    }
}

export default connect(AdviceEdit.mapStateToProps, {
    fetchAdvice, editAdvice,
})(AdviceEdit);
